import React from "react";
import AppContainer from "./appcontainer.jsx";
import { BrowserRouter as Router, Route } from "react-router-dom";
import {
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query';

const queryClient = new QueryClient();
const AppRouter = () => {
  // const config = "/template/react";
  return (
    <QueryClientProvider client={queryClient}>
    <Router basename="">
      <Route render={(props) => <AppContainer {...props} />} />
    </Router>
    </QueryClientProvider>
  );
};

export default AppRouter;
